import { WithStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { Routes, Screens } from '../utils/Routes';

const ITEM_HEIGHT = 48;

const styles = (theme: Theme) =>
	createStyles({
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
	});

/**
 * カリキュラムタイプ
 */
export enum CurriculumTypes {
	ONGOING,
	RESULT,
}

interface IState {
	functionMenus?: JSX.Element;
	selectColumnsMenuAnchorEl?: HTMLElement;
}

/**
 * カリキュラムテーブル形式
 */
class ImstatCurriculumTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {};
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getSelectedColumns();

		return (
			<>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.createTrProps(classes)}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.state.selectColumnsMenuAnchorEl &&
					this.getSelectColumnsMenu()}
				{this.state.functionMenus}
			</>
		);
	}

	/**
	 * 操作メニュー取得処理
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData: Actions.ICurriculum
	): JSX.Element {
		return (
			<Menu
				anchorEl={functionMenuAnchorEl}
				open={Boolean(functionMenuAnchorEl)}
				onClose={this.handleCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: 200,
					},
				}}
			>
				<MenuItem onClick={this.handleShowContent(rowData)}>
					{i18n.t('ImstatCurriculumTable_0001')}
				</MenuItem>
				<MenuItem onClick={this.handleShowDetail(rowData)}>
					{i18n.t('ImstatCurriculumTable_0002')}
				</MenuItem>
				{this.props.type === CurriculumTypes.ONGOING &&
					rowData.lecCancelOkFlg && (
						<MenuItem onClick={this.handleShowStCancel(rowData)}>
							{i18n.t('ImstatCurriculumTable_0003')}
						</MenuItem>
					)}
				{this.props.type === CurriculumTypes.ONGOING &&
					rowData.appCancelOkFlg && (
						<MenuItem
							onClick={this.handleShowCancelApplication(rowData)}
						>
							{i18n.t('ImstatCurriculumTable_0004')}
						</MenuItem>
					)}
			</Menu>
		);
	}

	/**
	 * カリキュラム内容表示
	 * @param event イベントオブジェクト
	 */
	protected handleShowContent = (rowData: Actions.ICurriculum) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		const { careerID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_CONTENT);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:cur_type/, `/${this.props.type}`);
		this.props.pushHistory(to);
	};

	/**
	 * カリキュラム詳細情報表示
	 * @param event イベントオブジェクト
	 */
	protected handleShowDetail = (rowData: Actions.ICurriculum) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_DETAIL);
		to = to.replace(/\/:curriculum_id/, `/${rowData.careerID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenus: undefined });
	};

	protected handleShowDetailDialog = (rowData: Actions.ICurriculum) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: rowData.careerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: true,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 受講取消画面表示
	 * @param event イベントオブジェクト
	 */
	protected handleShowStCancel = (rowData: Actions.ICurriculum) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${rowData.careerID}`);
		to = to.replace(/\/:class_id/, `/CL000000`);
		to = to.replace(/\/:curriculum_flg/, `/1`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param event イベントオブジェクト
	 */
	protected handleShowCancelApplication = (rowData: Actions.ICurriculum) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
		to = to.replace(/\/:career_id/, `/${rowData.careerID}`);
		to = to.replace(/\/:class_id/, `/CL000000`);
		to = to.replace(/\/:apl_type/, `/${rowData.aplType}`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowApplicationStatus = (rowData: Actions.ICurriculum) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, aplType } = rowData;
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: aplType,
			careerID,
			classID: 'CL000000',
			curriculumFlg: '1',
			setApplicationStatusDialog: true,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 行プロパティ生成
	 * @param state 状態オブジェクト
	 * @param rowInfo 行情報
	 */
	protected createTrProps = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * 全カラム定義取得
	 */
	protected getAllColumns(): any[] {
		const columns: any[] = [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<IconButton
							aria-label="More"
							aria-owns={
								this.state.functionMenus
									? 'long-menu'
									: undefined
							}
							aria-haspopup="true"
							key={row.value}
							data-index={row.index}
							onClick={this.handleOpenMenu}
							className={this.props.classes.menuButton}
							size="small"
						>
							<MenuIcon />
						</IconButton>
					);
				},
				accessor: 'careerID',
				required: true,
				sortable: false,
				width: 40,
			},
			{
				Header: i18n.t('ImstatCurriculumTable_0005'),
				accessor: 'compulsoryID',
				width: 80,
			},
			{
				Cell: (row: RowRenderProps) => {
					return (
						<span
							className={this.props.classes.link}
							onClick={this.handleShowDetailDialog(row.original)}
						>
							{row.original.careerTitle}
						</span>
					);
				},
				Header: i18n.t('ImstatCurriculumTable_0006'),
				accessor: 'careerTitle',
				width: 300,
			},
			{
				Header: i18n.t('ImstatCurriculumTable_0007'),
				accessor: 'target',
			},
			{
				Header: i18n.t('ImstatCurriculumTable_0008'),
				accessor: 'organizer',
			},
			{
				Header: i18n.t('ImstatCurriculumTable_0009'),
				accessor: 'credit',
			},
		];
		// 実績の場合は終了日時を表示
		if (this.props.type === CurriculumTypes.RESULT) {
			columns.push({
				Header: i18n.t('ImstatCurriculumTable_0010'),
				accessor: 'complDate',
			});
		}
		columns.push({
			Cell: (row: RowRenderProps) => {
				const targetAplTypes: string[] = ['0', '1', '2', '3', '4'];
				const status = i18n.t(row.value, { ns: 'force' });
				if (targetAplTypes.indexOf(row.original.aplType) !== -1) {
					return (
						<span
							className={this.props.classes.link}
							onClick={this.handleShowApplicationStatus(
								row.original
							)}
							data-index={row.index}
						>
							{status}
						</span>
					);
				}
				return <div>{status}</div>;
			},
			Header: i18n.t('ImstatCurriculumTable_0011'),
			accessor: 'status',
		});

		return columns;
	}

	/**
	 * 選択カラム取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * カラム選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 操作メニューオープン
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: Actions.ICurriculum = this.props.data[index];
			const functionMenus = this.getFunctionMenus(
				event.currentTarget,
				rowData
			);
			this.setState({ functionMenus });
		}
	};

	/**
	 * 操作メニュークローズ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenus: undefined });
	};

	/**
	 * カラム選択メニューオープン
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * カラム選択メニュークローズ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * 表示カラム選択変更
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === CurriculumTypes.ONGOING) {
			this.props.setOnGoingSelectedColumns(newSelectedColumns);
		} else if (this.props.type === CurriculumTypes.RESULT) {
			this.props.setResultSelectedColumns(newSelectedColumns);
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setOnGoingSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatOnGoingCurriculumSelectedColumns({
				selectedColumns,
			})
		),
	setResultSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setImstatResultCurriculumSelectedColumns({
				selectedColumns,
			})
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface IImstatCurriculumTableProps {
	data: Actions.ICurriculum[];
	selectedColumns: number[];
	type: CurriculumTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatCurriculumTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatCurriculumTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ImstatCurriculumTable.tsx